angular.module('gym').controller('ViewSampleBookingNotificationMessageCtrl', ["$scope", "$rootScope", "$modalInstance", "type", "website", function($scope, $rootScope, $modalInstance, type, website) {
  var contents, gym, reminderSmsContacts;
  gym = $rootScope.gym;
  reminderSmsContacts = website.phone ? `Questions? Call ${website.phone}` : `Questions? Email ${website.email}`;
  contents = {
    confirmation_email: {
      title: 'Sample content: Booking confirmation email',
      subject: `New event booked at ${gym.name}`,
      body: `<p>Hi <mark>{first name}</mark>,</p>
<p>&nbsp;</p>
<p>This is a confirmation of your booking for the <mark>{event name}</mark> event which starts <mark>{event date/time}</mark>.</p>
<p>&nbsp;</p>
<p>If you have any questions please contact us at <mark>{contact details}</mark>.</p>
<p>&nbsp;</p>
<p>Kind regards,</p>
<p>${gym.name}</p>
<p>&nbsp;</p>
<p><mark>{Add to google calendar link}</mark></p>`
    },
    reminder_email: {
      title: 'Sample content: Booking reminder email',
      subject: `Event reminder for ${gym.name}`,
      body: `<p>Hi <mark>{first name}</mark>,</p>
<p>&nbsp;</p>
<p>This is a reminder that you're booked into the <mark>{event name}</mark> event which starts <mark>{event date/time}</mark>.</p>
<p>&nbsp;</p>
<p>If you have any questions please contact us at <mark>{contact details}</mark>.</p>
<p>&nbsp;</p>
<p>Kind regards,</p>
<p>${gym.name}</p>
<p>&nbsp;</p>
<p><mark>{Add to google calendar link}</mark></p>`
    },
    reminder_sms: {
      title: 'Sample content: Booking reminder SMS"',
      body: `<p>Hi <mark>{first name}</mark>, BOOKING REMINDER for <mark>{event name}</mark> on <mark>{event date/time}</mark>.</p>
<p>${reminderSmsContacts}</p>`
    }
  };
  $scope.content = contents[type];
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
